import {Component, Inject, Input, LOCALE_ID} from '@angular/core';

@Component({
    selector: 'app-indian-currency-formatter',
    templateUrl: './indian-currency-formatter.html',
})
export class IndianCurrencyFormatterComponent {
    @Input('amount')
    public readonly amount: number;
    @Input('currencySymbolFontSize')
    public readonly currencySymbolFontSize = '85%';
    private readonly locale: string;
    @Input('minimumFractionDigits')
    public readonly minimumFractionDigits: number = 2;

    constructor(@Inject(LOCALE_ID) locale: string) {
        this.locale = locale;
    }

    transform(value: number): any {
        const formattedValue = new Intl.NumberFormat(this.locale, {
            style: 'decimal',
            minimumFractionDigits: this.minimumFractionDigits,
            maximumFractionDigits: 2
        }).format(value);
        return `${formattedValue}`;
    }
}